export const videos = [
  {
    title: 'Drama Radio 2',
    url: 'https://www.youtube.com/watch?v=Zln73z-I6Tg',
    description: 'A selection of sexy tracks for a drink or two.',
  },
  {
    title: 'Radio Escondido',
    url: 'https://www.youtube.com/watch?v=TSAZusQUqNE',
    description:
      'Two hours of acid, dub, techno, synth, dark wave, electronica, low tempo, fast tempo and in between.',
  },
  {
    title: 'Drama Radio',
    url: 'https://www.youtube.com/watch?v=0C97axTt0aU',
    description: 'DJ set at Drama Radio.',
  },
  {
    title: 'Polymorphism',
    url: 'https://www.youtube.com/watch?v=lMWASTduN78',
    description:
      'Polymorphism is an audiovisual exploration at the intersection of sound, image, and code. Inspired by the concept of polymorphism in programming-where a single function can take multiple forms-this track reflects coast2c fascination with generative systems, modular synthesis, and the evolving role of technology in music creation. The accompanying AI-generated visuals translate the dynamic layers of the piece into a shifting visual narrative, echoing the tracks structure of controlled unpredictability and transformation. Video by Coast2c using Stable Diffusio to create generative visuals. The track is part of her latest EP Machine Music, Human Dance.',
  },
  {
    title: 'Modular World',
    url: 'https://www.youtube.com/watch?v=7Gx6aCv0OqA',
    description:
      'Modular World is a Live-stream event celebrating the global modular community. Coast2c joins a powerful line up of modular synth artists in Mexico, sharing an immersive live modular performance that celebrates the rich, evolving landscape of electronic music in Latin America. Coast2c, an experimental female music producer and sound artist, explores the raw sonic textures of Eurorack synthesis, blending hypnotic rhythms, analog noise, and improvisation to create a deeply personal sound and a raw strong techno set. As part of this global modular synthesis community, this appearance showcases Coast2c commitment to pushing bounderies in techno, ambient, and electronic performance through hardware-based production and live synthesis.',
  },
  {
    title: 'Mente maleable',
    url: 'https://www.youtube.com/watch?v=RdoIXigYmfo',
    description:
      'Video by Doctor Bagre, music by Coast2c. Out via Krater Music ',
  },

  {
    title: 'Live - Pierce b and Coast2c',
    url: 'https://www.youtube.com/watch?v=bV_UATaGpuE&t=572s',
    description: 'Jam session with Pierce b synced to a Processing sketch',
  },
  {
    title: 'Obsidian Pulse',
    url: 'https://player.vimeo.com/video/363953918?h=4aeb110f4f',
    description:
      'Sound design for Obsidian Pulse. A collaboration with Julieta Gil and Ana Gonzales of Punta de Lanza and Janet40.',
  },
  {
    title: 'Ephemeral',
    url: 'https://www.youtube.com/watch?v=4p9e7ERufYo',
    description:
      'Experimental video collaboration with digital artist Julieta Gil, we merged sound and video together for an interactive piece manipulated by the signal of multiple oscillators.',
  },
  {
    title: 'Question your privilege of species',
    url: 'https://www.youtube.com/watch?v=Asy8ELWY4Tc',
    description: 'Processing sketch and sound design.',
  },
  {
    title: 'Kinowatt Film Festival 2021',
    url: 'https://www.youtube.com/watch?v=3RELBpccQf0',
    description:
      'Performance and panel discussion at Kinowatt Film Festival for University of Pennsylvania and The Annenberg Center for the Performing Arts.',
  },
  {
    title: 'Kontaktor 2019',
    url: 'https://www.youtube.com/watch?v=U9Al3POAzvU',
    description:
      'Kontaktor is Erica Synths music festival dedicating to presenting forward-pushing live electronic music- from left-field techno and seminal electro, to nonconformist industrial and bizarre experimental noise. As part of Phase II, Coast2c delivers a live modular synth performance, blending hypnotic textures, improvisation, and analog chaos in a hardware-driven set enhanced by an immersive laser show by BT-laser. <a href="https://kontaktor.lv/kontaktor-2019"> Phase II.</a>',
  },
];
